import { CommentSource, CommentContactedBy } from "~/api/myedvenn/comment";
import { AttendanceStatus } from '~/api/myedvenn/attendance';
import { AssignStatus } from "~/api/myedvenn/contact_package";
import { ContactTitle } from "~/api/myedvenn/contact";
import { TrainingStatus } from "~/util";
import { UserRole } from "~/api/myedvenn/user";
import { DocumentType } from "~/api/myedvenn/document";
import { ApplicationAssetCategory, ApplicationDecision, ApplicationStatus } from "~/api/myedvenn/package_file";

// TokenRight
// FileLinkEntity
// ErrorCode
// ReportType

export default defineNuxtPlugin(() => ({
    provide: {
        enum: {
            CommentContactedBy: enumDisplay(CommentContactedBy, {
                [CommentContactedBy.UNDEFINED_CommentCatgory]: '',
                [CommentContactedBy.EMAIL]: 'Mail',
                [CommentContactedBy.INTERNE]: 'Interne',
                [CommentContactedBy.MAIL]: 'Courrier',
                [CommentContactedBy.MODULE_END]: 'Fin de module',
                [CommentContactedBy.PHONE]: 'Tél.',
                [CommentContactedBy.MARKETING]: 'Marketing',
                [CommentContactedBy.REVIEW]: 'Correction',
            }),
            CommentSource: enumDisplay(CommentSource, {
                [CommentSource.UNDEFINED_CommentSource]: '',
                [CommentSource.GLOBAL]: 'global',
                [CommentSource.PACKAGE_HISTORY]: 'PACKAGE_HISTORY',
                [CommentSource.PACKAGE_ADMINISTRATIVE]: 'PACKAGE_ADMINISTRATIVE',
                [CommentSource.PACKAGE_ATTENDANCES]: 'PACKAGE_ATTENDANCES',
                [CommentSource.PACKAGE_TRACKING]: 'PACKAGE_TRACKING',
            }),
            AttendanceStatus: enumDisplay(AttendanceStatus, {
                [AttendanceStatus.UNDEFINED_AttendanceStatus]: '',
                [AttendanceStatus.DRAFT]: 'DRAFT',
                [AttendanceStatus.DRAFT__WAITING]: 'DRAFT__WAITING',
                [AttendanceStatus.TO_BE_VALIDATED]: 'TO_BE_VALIDATED',
                [AttendanceStatus.REJECTED]: 'REJECTED',
                [AttendanceStatus.RECEIVED]: 'RECEIVED',
                [AttendanceStatus.RECEIVED__ARCHIVED]: 'RECEIVED__ARCHIVED',
            }),
            AssignStatus: enumDisplay(AssignStatus, {
                [AssignStatus.UNDEFINED_AssignStatus]: '',
                [AssignStatus.DRAFT]: "Brouillon en attente d'envoi pour évaluation",
                [AssignStatus.SUBMITTED]: 'Devoir envoyé pour évaluation',
                [AssignStatus.CORRECTED]: 'Devoir corrigé',
            }),
            ContactTitle: enumDisplay(ContactTitle, {
                [ContactTitle.UNDEFINED_ContactTitle]: '',
                [ContactTitle.SIR]: 'M.',
                [ContactTitle.MADAM]: 'Mme',
                [ContactTitle.MISS]: 'Mlle',
            }),
            TrainingStatus: enumDisplay(TrainingStatus, {
                // [TrainingStatus.UNDEFINED_TrainingStatus]: '',
                [TrainingStatus.NEXT]: 'À venir',
                [TrainingStatus.WIP]: 'En cours',
                [TrainingStatus.ENDED]: 'Terminé',
            }),
            UserRole: enumDisplay(UserRole, {
                [UserRole.UNDEFINED_UserRole]: '',
                [UserRole.USER_ADVISER]: 'Conseiller formation',
                [UserRole.USER_MONITOR]: 'Référent pédagogique',
                [UserRole.USER_ASSISTANT]: 'Assistante',
            }),
            DocumentType: enumDisplay(DocumentType, {
                [DocumentType.UNDEFINED_DocumentType]: '',
                [DocumentType.INVOICE]: 'Facture',
                [DocumentType.PIF]: 'Protocole individuel de formation',
                [DocumentType.TRAINING_AGREEMENT]: 'Convention',
                [DocumentType.CONTRACT]: 'Contrat',
                [DocumentType.TRAINING_CERTIFICATE]: 'Attestion de formation',
                [DocumentType.ATTENDANCE_CERTIFICATE]: 'Attestion d’assiduité',
                [DocumentType.ADMISSION_CERTIFICATE]: 'Attestion d’admission',
            }),

            ApplicationAssetCategory : enumDisplay(ApplicationAssetCategory, {
                [ApplicationAssetCategory.CV]: 'cv',
                [ApplicationAssetCategory.PP]: 'pp',
                [ApplicationAssetCategory.TEST]: 'test',
                [ApplicationAssetCategory.RTEST]: 'rtest',
            }),
            ApplicationDecision : enumDisplay(ApplicationDecision, {
                [ApplicationDecision.ADMITTED]: 'Admis',
                [ApplicationDecision.CONDITIONALLY_ADMITTED]: 'Admis avec réserves',
                [ApplicationDecision.WAITING]: 'En attente',
                [ApplicationDecision.REJECTED]: 'Non admis',
            }),
            ApplicationStatus : enumDisplay(ApplicationStatus, {
                [ApplicationStatus.ACTIVE]: 'Active',
                [ApplicationStatus.CANCELED]: 'Sans suite',
            })
        }
    }
}))

function enumDisplay<T>(enumm: T, translation: Record<number, string>) {
    const ordinal = enumOrdinal(enumm)
    return {
        ...enumm,

        get values() { return ordinal },

        translate(o?: number | string) {
            if (o === undefined) return ''

            const enumKey = typeof o === 'number' ? o : (enumm as any)[o] as number

            return translation[enumKey]
        }

    } as T & {
        values: number[];
        translate: (v?: number | string) => string;
    }
}

function enumOrdinal(enumm: any) {
    return Object.keys(enumm).filter(key => !isNaN(Number(key))).map(v => parseInt(v)).filter(x => !!x)
}